import React from 'react';
import { Button } from 'antd';
import { useMapContext } from '../context/map-context';

export const ConfigurationButton = (): JSX.Element => {
  const {
    onConfigurationDrawerHandler,
  } = useMapContext();
  return (
    <Button style={{ backgroundColor: '#190952', padding: '8 22' }} onClick={() => onConfigurationDrawerHandler()}>
      <span style={{
        fontSize: '12px', fontWeight: 500, color: '#FFFFFF',
      }}
      >
        Configuration
      </span>
    </Button>
  );
};
